import React, { useContext, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import '../../../assets/css/libs.css';
import '../../../assets/css/main.css';
import '../../../assets/css/custom.css';
import '../../../assets/css/dark.css';
import '../../../assets/css/rtl.css';
import '../../../assets/css/custom/layout.css';
import '../../../components/components.css';

import { LanguageContext } from '../../../lib/i18n/LanguageProvider';
import LanguageSelector from '../../../lib/i18n/LanguageSelector';
import ThemeToggle from '../../../components/ThemeToggle';
import FullScreenToggle from '../../../components/FullScreenToggle';

const Layout: React.FC = () => {
  const { lang } = useParams();
  const context = useContext(LanguageContext);
  const [pageTitle, setPageTitle] = useState<string>("");
  const [pageTitle2, setPageTitle2] = useState<string>("");
  const [pageTitle3, setPageTitle3] = useState<string>("");

  if (!context) {
    return <></>;
  }

  const { translations } = context;

  return (
    <main className="main-content">
      <nav className="nav navbar">
        <div className="container-fluid navbar-inner">
          <div className="text-start fw-bold fs-5 text-dark">
            {pageTitle}
            <br />
            {/* {pageTitle2}
            <br />
            {pageTitle3} */}
          </div>

          <div className="text-start">
            
          </div>

          <div className="d-flex align-items-center col-auto">
            {/* {lang && (
              <div className="m-2">
                <LanguageSelector />

              </div>
            )} */}
            <ThemeToggle />
            <FullScreenToggle />
          </div>
        </div>
      </nav>
      <Outlet context={{ setPageTitle, setPageTitle2, setPageTitle3 }} />
    </main>
  );
};

export default Layout;
